// extracted by mini-css-extract-plugin
module.exports = {"center":"Loading_center__39G1a"};